<script setup>
import { ref, reactive, watch, computed } from 'vue'
import { useServicePrices } from '@/composables/useServicePrices'
import { createToaster } from "@meforma/vue-toaster";

const props = defineProps({
  isOpen: Boolean,
  itemData: { type: Object, default: null },
  serviceName: String,
  rankName: String
})

const emit = defineEmits(['close', 'save-success'])
const { updateServicePricesApi } = useServicePrices()
const toaster = createToaster({ position: "top-right", duration: 2000 });

const loading = ref(false)
const formData = reactive({
  price: 0,
  zone: ''
})

watch(() => props.isOpen, (newVal) => {
  if (newVal && props.itemData) {
    formData.price = props.itemData.price
    formData.zone = props.itemData.zone
  }
}, { immediate: true })

const closeForm = () => {
  emit('close')
}

const handleSubmit = async () => {
  loading.value = true
  try {
    const res = await updateServicePricesApi(props.itemData.id, { price: formData.price })
    if (res.success) {
      toaster.success("Cập nhật giá thành công!");
      emit('save-success')
      closeForm()
    } else {
      toaster.error(res.error || 'Có lỗi xảy ra')
    }
  } catch (error) {
    toaster.error('Lỗi kết nối máy chủ')
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div v-if="isOpen" class="form-sidebar-overlay" @click.self="closeForm">
    <div class="form-sidebar">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4 class="fw-bold m-0">Cập nhật giá dịch vụ</h4>
        <button class="btn-close" @click="closeForm"></button>
      </div>

      <form @submit.prevent="handleSubmit">
        <div class="mb-3">
          <label class="form-label fw-semibold small text-muted text-uppercase">Dịch vụ</label>
          <input type="text" class="form-control bg-light" :value="serviceName" readonly>
        </div>

        <div class="mb-3">
          <label class="form-label fw-semibold small text-muted text-uppercase">Customer Rank</label>
          <input type="text" class="form-control bg-light" :value="rankName" readonly>
        </div>

        <div class="mb-3">
          <label class="form-label fw-semibold small text-muted text-uppercase">Vùng (Zone)</label>
          <input type="text" class="form-control bg-light" :value="formData.zone" readonly>
        </div>

        <div class="mb-3">
          <label class="form-label fw-semibold small text-dark text-uppercase">Giá mới *</label>
          <div class="input-group">
            <span class="input-group-text bg-white"><i class="fa fa-dollar text-primary"></i></span>
            <input type="number" class="form-control" v-model="formData.price" step="0.01" required>
          </div>
        </div>

        <div class="d-flex gap-2 mt-5 pt-3 border-top">
          <button type="button" class="btn btn-secondary w-100" @click="closeForm">Hủy bỏ</button>
          <button type="submit" class="btn btn-primary w-100" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
            CẬP NHẬT
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.form-sidebar-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.4);
  z-index: 9999 !important;
}
.form-sidebar {
  position: fixed;
  top: 0; right: 0;
  width: 420px; height: 100%;
  background: white;
  padding: 30px;
  box-shadow: -5px 0 15px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  overflow-y: auto;
  transition: all 0.3s ease;
}
@media (max-width: 576px) {
  .form-sidebar {
    width: 100% !important;
    padding: 20px;
  }
}
@keyframes slideIn {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}
.form-control:read-only {
  background-color: #f8f9fa !important;
  border-color: #eee;
}
</style>
